const purchasePaymentMethodEnum = Object.freeze({
    
    CASH        :5,
    CHEQUE      : 10,
    CREDIT_CARD : 15,
    OTHERS      : 20,
});
export default purchasePaymentMethodEnum;
